import { TFunction } from 'i18next'

import { ActivityTypeEnum } from '@/api/clients/get-client-activities'
import { SelectOption } from '@/components/ui/select'

import { ActivityType, RecentActivitiesFilters } from './recent-activities.types'

export const ALL_ACTIVITIES_VALUE = 'all'

export const makeActivityTypeLabels = (
  t: TFunction<['clients']>,
): Record<ActivityType, string> => ({
  [ActivityTypeEnum.enum.guest]: t('clients:recentActivities.categories.guest'),
  [ActivityTypeEnum.enum.maintenance]: t('clients:recentActivities.categories.maintenance'),
  [ActivityTypeEnum.enum.note]: t('clients:recentActivities.categories.note'),
  [ActivityTypeEnum.enum.package]: t('clients:recentActivities.categories.package'),
  [ActivityTypeEnum.enum.post]: t('clients:recentActivities.categories.post'),
  [ActivityTypeEnum.enum.reservation]: t('clients:recentActivities.categories.reservation'),
})

export const makeCategoryOptions = (t: TFunction<['clients']>): SelectOption<string>[] => {
  const activityTypeLabels = makeActivityTypeLabels(t)

  return [
    { label: t('clients:recentActivities.categories.all'), value: ALL_ACTIVITIES_VALUE },
    ...(Object.entries(activityTypeLabels) as [ActivityType, string][]).map(([value, label]) => ({
      label,
      value,
    })),
  ]
}

export const DEFAULT_LIMIT = 25

export const INITIAL_FILTERS: RecentActivitiesFilters = {
  categories: [],
  dateRange: [null, null],
  limit: DEFAULT_LIMIT,
  skip: 0,
}
